import React from "react";
import { SettingOutlined } from "@ant-design/icons";
import { Tooltip, Button } from "antd";

function Footer({ children }) {
  return (
    <div className="footer">
      <div className="footer_alignment_container">
        {/* <Button
          className="default_button"
          onClick={handleSettingsToggle}
        >
          <SettingOutlined className="icon" />
        </Button> */}

        {children}
      </div>
    </div>
  );
}

export default Footer;
